import { useQuery } from '@tanstack/react-query'
import { creatorsLegalityQueryOptions } from '@/layouts/creator/api'
import { Country, UnitedStates } from '@/api/dashboard'
import dayjs from 'dayjs'

export const useCreatorLegality = (token: string, dob: Date, country: Country, state?: UnitedStates) => {
  const query = creatorsLegalityQueryOptions(token, {
    date_of_birth: dayjs(dob).format('YYYY-MM-DD'),
    country: country,
    state: state,
  })
  const { data: response, isLoading, isError } = useQuery({ ...query, enabled: !!(dob && country) })

  return {
    isMinor: response?.is_minor,
    isLoading,
    isError,
  }
}
